export const TOTAL_PAGINATION = Number.MAX_SAFE_INTEGER;
export const DELETE_PROPERTY_PREFIX = "DELETE_THIS_";
export const QATAR_CODE_PREFIX = "+974";
